<template>
  <master-layout
    smallTitle="modifica"
    bigTitle="Rilevazione"
    titleStyle="horizontal"
  >
    <div class="relative">
      <div class="grid-center mb-4">
        <label
          v-if="loading"
          style="
            width: 100%;
            min-width: 300px;
            min-height: 150px;
            border-radius: 10px;
            display: grid;
            place-content: center;
            border: 1px solid goldenrod;
            color: goldenrod;
            font-weight: bold;
            font-size: 1.2rem;
            margin-top: 30px;
            padding: 1.2rem;
          "
          >Caricamento delle immagini in corso...</label
        >
        <button
          v-if="!loading"
          @click="triggerFileUploader"
          class="px-4 py-3 button-primary"
        >
          {{
            rilevazione.elementiMultimediali.length > 0
              ? "Tocca per caricare altre immagini"
              : "Tocca per caricare immagini"
          }}
        </button>

        <div
          v-if="!loading"
          style="
            width: 100%;
            min-width: 300px;
            height: 150px;
            display: grid;
            place-content: center;
            border-radius: 10px;

            margin-top: 30px;
          "
          :style="{
            border: 1 + 'px dashed ' + (isDragging ? '#011307' : '#110F03'),
            'background-color': isDragging ? '#D8FDE5' : '#FCF9ED',
          }"
          @dragover.prevent.stop="onDragOver($event)"
          @dragleave.prevent.stop="onDragLeave($event)"
          @drop.prevent="onDrop($event)"
          @paste="handlePaste($event)"
        >
          <span>O caricale trascinandole qui</span>
        </div>

        <input
          style="display: none"
          id="images-uploader"
          type="file"
          name="filefield"
          multiple
          @change="handleFileInput"
        />
      </div>
      <span v-if="rilevazione.elementiMultimediali.length > 0"
        >Hai caricato delle immagini, scrolla in fondo alla pagina per vederne
        la miniatura</span
      >

      <div class="ion-margin-bottom ion-padding-bottom">
        <ion-row class="ion-margin-top ion-padding-top">
          <ion-col>
            <ion-item>
              <ion-textarea
                :autoGrow="true"
                :rows="2"
                placeholder="Descrizione"
                v-model="rilevazione.descrizione"
              ></ion-textarea>
            </ion-item>
            <ion-item class="ion-margin-top">
              <ion-input
                placeholder="Luogo"
                inputmode="text"
                @ionFocus="setFocusTrue"
                @ionBlur="setFocusFalse"
                maxlength="50"
                v-model="rilevazione.luogo"
              ></ion-input>
            </ion-item>
            <ion-item class="ion-margin-top">
            <ion-datetime
                label="Fecha"
                label-placement="stacked"
                presentation="date"
                :min="minDate"
                :max="maxDate"
                :value="currentDate"
                @ionChange="handleDateChange($event.detail.value)"
              ></ion-datetime>
            </ion-item>

          <ion-item class="ion-margin-bottom">
              <ion-input
                  label="Hora"
                  label-placement="stacked"
                  type="time"
                  :value="selectedTime"
                  @ionChange="handleTimeChange($event.detail.value)"
              ></ion-input>
          </ion-item>

          </ion-col>
        </ion-row>
      </div>

      <div
        class="ion-margin-bottom ion-padding background-white flex justify-content-start align-items-center"
      >
        <span>Seleziona gli indagati:</span>

        <ion-select
          v-model="rilevazione.indagati"
          :multiple="true"
            :interface-options="{
              header: 'Seleziona gli indagati',
            }"
            :selected-text="selectedIndagatiText"
          class="ion-margin-top ion-margin-bottom"
        >
          <ion-select-option
            v-for="indagato of (ordineDiServizio && ordineDiServizio.indagati ? ordineDiServizio.indagati : [])"
            :key="indagato"
            :value="indagato"
            >{{ indagato }}</ion-select-option
          >
        </ion-select>
        <!-- <div class="ml-2 selected-indagati" v-if="selectedIndagatiText">
          {{ selectedIndagatiText }}
        </div> -->
      </div>

      <div class="galleria pb-6">
        <div
          @click="showModal(index)"
          class="gal-image"
          v-for="(image, index) in rilevazione.elementiMultimediali"
          :key="index"
        >
          <img :src="image.urlElemento" @error="handleImgError" />
          <ion-icon
            @click="deleteImage(image)"
            :icon="trashOutline"
            class="delete-badge"
          ></ion-icon>
        </div>
      </div>

      <button
  :disabled="loading || disabled"
  @click="confirmSave"
  class="fixed bottom center button-bottom-axerta-secondary w-75 text-16"
>
  Salva
</button>


      <!-- <button
        :disabled="loading || disabled"
        @click="salvaRilevazione"
        class="fixed bottom center button-bottom-axerta-secondary w-75 text-16"
      >
        Salva
      </button> -->
    </div>
    <div id="bottom-component" class="bottom-component">
      <div v-if="tastieraFocus"></div>
    </div>
  </master-layout>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import MasterLayout from "../../components/MasterLayout.vue";
import { toastController } from "@ionic/vue";
import ApiService from "../../common/service.api";
import { trashOutline } from "ionicons/icons";
import { useAxertaStore } from "@/stores/useAxertaStore";

import {
  IonAvatar,
  IonLabel,
  IonSelectOption,
  IonRow,
  IonCol,
  IonCard,
  IonList,
  IonItem,
  IonInput,
  IonSelect,
  IonTextarea,
  IonIcon,
  IonButton,
  IonFab,
  IonFabButton,
  modalController,
  IonDatetime,
  //   IonRouterOutlet,
  loadingController,
  IonLoading,
  alertController
} from "@ionic/vue";

const route = useRoute();
const router = useRouter();

const AXERTA_STORE = useAxertaStore();

const ordineDiServizio = ref(AXERTA_STORE.ordineDiServizio);

const tastieraFocus = ref(false);
const isDragging = ref(false);

function handleDateChange(value) {
    // value viene como 'YYYY-MM-DDT00:00:00.000Z'
    if (value) {
        selectedDate.value = value.split('T')[0];
    }
    updateFinalDateTime();
}

function handleTimeChange(event) {
    // El input type="time" devuelve la hora en formato HH:mm
  // The template passes $event.detail.value (a string like 'HH:mm').
  // Accept either the raw value or an event object for robustness.
  if (!event) return;
  if (typeof event === "string") {
    selectedTime.value = event;
  } else if (event.detail && typeof event.detail.value === "string") {
    selectedTime.value = event.detail.value;
  } else if (event.target && event.target.value) {
    selectedTime.value = event.target.value;
  }
  updateFinalDateTime();
}

function updateFinalDateTime() {
    if (selectedDate.value && selectedTime.value) {
        // Combina la fecha (YYYY-MM-DD) y la hora (HH:mm) en el formato ISO 8601 esperado (YYYY-MM-DDT-HH:mm:00)
        const finalDateTime = `${selectedDate.value}T${selectedTime.value}:00`;
        rilevazione.value.dataOra = finalDateTime;
        console.log("Fecha y Hora Combinada:", rilevazione.value.dataOra);
    } else {
        rilevazione.value.dataOra = ''; // O manejar el error si faltan datos
    }
}

function initializeDateTime() {
    const fullDateTime = rilevazione.value.dataOra;
    if (fullDateTime) {
        const parts = fullDateTime.split('T');
        selectedDate.value = parts[0]; // YYYY-MM-DD
        // Aseguramos que la hora sea HH:mm (quitando los segundos y zona horaria)
        selectedTime.value = parts[1].substring(0, 5); // HH:mm
    } else {
        // Si no hay valor, usa el valor mínimo para la fecha
        const minParts = minDate.value.split('T');
        selectedDate.value = minParts[0];
        selectedTime.value = '12:00'; // Hora por defecto
    }
    // Llamamos a la función original de cambio una vez al inicio
    updateFinalDateTime();
}

onMounted(() => {
    // get rilevazione from localhost
    getRilevazioneFromLoocalHost();
    // Inicializar las variables separadas con el valor cargado de rilevazione.value.dataOra
    initializeDateTime(); 
    rilevazione.value.indagati ? null : (rilevazione.value.indagati = []);
});

async function confirmSave() {
  const alert = await alertController.create({
    header: "Conferma",
    message: "Sei sicuro di voler salvare la rilevazione?",
    buttons: [
      {
        text: "Annulla",
        role: "cancel",
      },
      {
        text: "Conferma",
        handler: () => {
          salvaRilevazione(); // Llama a la función de guardado
        },
      },
    ],
  });
  await alert.present();
}

function deleteImage(image) {
  const index = rilevazione.value.elementiMultimediali.indexOf(image);
  rilevazione.value.elementiMultimediali.splice(index, 1);
}

function setFocusTrue() {
  tastieraFocus.value = true;
  scrollDown();
}
function setFocusFalse() {
  tastieraFocus.value = false;
}
function scrollDown() {
  document
    .querySelector("#bottom-component")
    .scrollIntoView({ behavior: "smooth" });
}

function onDragOver(event) {
  event.preventDefault();
  isDragging.value = true;
}
function onDragLeave(event) {
  event.preventDefault();
  isDragging.value = false;
}
function onDrop(event) {
  event.preventDefault();
  isDragging.value = false;
  handleFileInput({ target: { files: event.dataTransfer.files } });
}

function handlePaste(event) {
  console.log(event);
  // handleFileInput({ target: { files: event.clipboardData.files } });
}

const disabled = computed(() => {
  if (
    rilevazione.value.luogo.length > 0 &&
    rilevazione.value.descrizione.length > 0 &&
    rilevazione.value.elementiMultimediali.length > 0 &&
    rilevazione.value.dataOra.length > 0
  ) {
    return false;
  }
  return true;
});

const selectedIndagatiText = computed(() => {
  const list = rilevazione.value.indagati || [];
  return list.length > 0 ? list.join(", ") : "";
});

const rilevazione = ref({
  descrizione: "",
  elementiMultimediali: [],
  luogo: "",
  dataOra: "",
  stato: "3",
});

const selectedDate = ref(''); 
const selectedTime = ref('')

function handleImgError() {
  return "https://placehold.co/300x300?text=MartechRevolution";
}

function getRilevazioneFromLoocalHost() {
  const rilevazioneFromLocalHost = JSON.parse(
    localStorage.getItem("axerta-currentRilevazione")
  );

  console.log("rilevazioneFromLocalHost", rilevazioneFromLocalHost);
  if (rilevazioneFromLocalHost) {
    rilevazione.value.luogo = rilevazioneFromLocalHost.luogoInizio || rilevazioneFromLocalHost.luogoFine;
    rilevazione.value.descrizione =
      rilevazioneFromLocalHost.descrizioneHistory[
        rilevazioneFromLocalHost.descrizioneHistory.length - 1
      ].testo;
    // Prefer the editingDate if the list view stored it (this matches what the user saw)
    rilevazione.value.dataOra = rilevazioneFromLocalHost.editingDate
      ? rilevazioneFromLocalHost.editingDate
      : rilevazioneFromLocalHost.dataOraInizio;
    // populate indagati if present in the stored rilevazione
    rilevazione.value.indagati = rilevazioneFromLocalHost.indagati || [];
    rilevazione.value.elementiMultimediali =
      rilevazioneFromLocalHost.elementiMultimediali || [];
    rilevazione.value.stato = rilevazioneFromLocalHost.stato;
    rilevazione.value.id = rilevazioneFromLocalHost.id;
  }

  // Ensure the separated date/time fields are initialized after loading
  initializeDateTime();
}

const minDate = computed(() => {
  return new Date(route.params.inizioIntervento).toISOString().slice(0, 19);
});

const maxDate = computed(() => {
  if (route.params.fineIntervento == "in-corso") {
    let date = new Date();
    let year = date.getFullYear();
    let month = (date.getMonth() + 1).toString().padStart(2, "0");
    let day = date.getDate().toString().padStart(2, "0");
    let hour = date.getHours().toString().padStart(2, "0");
    let minute = date.getMinutes().toString().padStart(2, "0");

    return `${year}-${month}-${day}T${hour}:${minute}`;
  } else {
    return new Date(route.params.fineIntervento).toISOString().slice(0, 19);
  }
});

const modalVisible = ref(false);
const currentImageIndex = ref("");

function handleDateTimeChange(event) {
  console.log("handle datetime change", event);

  let ora = event;

  rilevazione.value.dataOra = ora;

  console.log("handle datetime change", rilevazione.value);
}

const loading = ref(false);

function handleFileInput(event) {
  loading.value = true;
  const promises = [];

  for (let i = 0; i < event.target.files.length; i++) {
    const formData = new FormData();
    formData.append("file", event.target.files[i]);
    promises.push(
      ApiService.post("Upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
    );
  }

  Promise.all(promises)
    .then((values) => {
      values.forEach((value) => {
        rilevazione.value.elementiMultimediali.push({
          urlElemento: "https://api-axerta.whappy.it/Drive/" + value.data,
        });
      });
    })
    .finally(() => {
      loading.value = false;
      presentToast("File caricato");
    });
}

function salvaRilevazione() {
  loading.value = true;
  if (!rilevazione.value.indagati) rilevazione.value.indagati = [];
  // ensure the separate date/time fields are synced and clamped to allowed range
  updateFinalDateTime();
  // clamp to min/max
  try {
    const minDt = new Date(minDate.value);
    const maxDt = new Date(maxDate.value);
    let finalDt = new Date(rilevazione.value.dataOra);
    if (isNaN(finalDt.getTime())) {
      // fallback: try to build from selectedDate/selectedTime
      finalDt = new Date(`${selectedDate.value}T${selectedTime.value}:00`);
    }
    if (finalDt > maxDt) {
      rilevazione.value.dataOra = formatDateWithOffset(maxDt);
    } else if (finalDt < minDt) {
      rilevazione.value.dataOra = formatDateWithOffset(minDt);
    } else {
      // Format with local offset to preserve local time when saved
      rilevazione.value.dataOra = formatDateWithOffset(finalDt);
    }
  } catch (e) {
    // if anything fails, keep existing value
    console.warn('Date clamp failed', e);
  }
  ApiService.put(
    "DossierManager/SaveRilevazione/" + rilevazione.value.id,
    rilevazione.value
  )
    .then((res) => {
      console.log(" success salva rilevazione ", res);
    })
    .finally(() => {
      rilevazione.value = {
        descrizione: "",
        elementiMultimediali: [],
        luogo: "",
        dataOra: "",
      };
      loading.value = false;
      localStorage.removeItem("axerta-currentRilevazione");
      router.push(
        {
          name: "ElencoRilevazioni",
          params: {
            idOrdine: route.params.idOrdine,
            idIntervento: route.params.idIntervento,
            inizioIntervento: route.params.inizioIntervento,
            fineIntervento: route.params.fineIntervento
              ? route.params.fineIntervento
              : "in-corso",
          },
        }

        // "/axerta/elenco-rilevazioni/" +
        //   route.params.idOrdine +
        //   "/" +
        //   route.params.idIntervento
      );
    });
}

async function presentToast(message) {
  const toast = await toastController.create({
    message: message,
    duration: 1500,
    position: "bottom",
    color: "success",
  });

  await toast.present();
}

function triggerFileUploader() {
  document.getElementById("images-uploader").click();
}

function formatDateWithOffset(date) {
  const pad = (n) => (n < 10 ? `0${n}` : `${n}`);
  const d = new Date(date);
  const tz = -d.getTimezoneOffset();
  const sign = tz >= 0 ? "+" : "-";
  const absTz = Math.abs(tz);
  const tzH = pad(Math.floor(absTz / 60));
  const tzM = pad(absTz % 60);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
    d.getDate()
  )}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}${sign}${tzH}:${tzM}`;
}
</script>

<style lang="scss" scoped>
.hello {
  position: relative;
}

.icon {
  position: absolute;
  top: 150px;
  left: 50%;
  transform: translateX(-50%);
}

.galleria {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  gap: 10px;
  padding: 10px;
}

.gal-image {
  position: relative;
  max-width: 30%;
  min-width: 100px;

  img {
    width: 100%;
    height: auto;
    border: 3px solid gray;
    border-radius: 5px;
  }

  .delete-badge {
    position: absolute;
    background-color: maroon;
    color: white;
    padding: 0.6rem;
    border-radius: 50%;
    top: -10px;
    right: -10px;
  }
}

.active {
  img {
    border: 4px solid rgb(85, 194, 85);
  }
}

.relative {
  position: relative;
}

.modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  z-index: 900000;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  padding: 1rem;
  background-color: rgb(255, 255, 255);
  // border: 2px solid gray;
  border-radius: 10px;
  box-shadow: 0px 9px 46px 8px rgba(0, 0, 0, 0.12),
    0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 11px 15px rgba(0, 0, 0, 0.2);

  .header {
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }

  .image-info {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex-grow: 1;
    padding: 1rem 0;
  }

  .current-image {
    display: grid;
    place-content: center;
  }
}

input[type="file"] {
  border: 1px solid rgb(165, 165, 165);
  border-radius: 7px;
  padding: 1rem 2rem;
}

// .custom-file-upload {
//   border: 1px solid #ccc;
//   display: inline-block;
//   padding: 6px 12px;
//   margin-bottom: 3rem;
//   border-radius: 5px;
//   padding: 0.5rem 1rem;
//   cursor: pointer;
//   box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.03), 0px 0px 2px rgba(0, 0, 0, 0.06),
//     0px 2px 6px rgba(0, 0, 0, 0.12);
// }

.bottom-component {
  width: 100%;
  padding-top: 50vh;
}
</style>
